export const PERMS = {
    READ: 'report_cost_center_profits.read',
    EXPORT: 'report_cost_center_profits.export',
}
